import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Button } from "@mui/material";
import { sendMailByMeetingIdPDFApi } from "api/notification";
import { getOneRecordByIdPDFApi, getPDFForEachDecisionByMeetingIdPDFApi, getReportListByMeetingIdPDFApi, getUsersByMeetingIdPDFApi } from "api/pdf";
import { getForEachDecisionByMeetingIdWORDApi, getOneRecordByIdWORDApi, getReportListByMeetingIdWORDApi, getUsersByMeetingIdWORDFApi } from "api/word";
import { createReportFileName, isRoleCheckList } from "app/utils/appHelpers";
import { useState } from "react";
import { useSelector } from "react-redux";
import UnclearSignatureDialog from "./Dialog/UnclearSignatureDialog";
function ReportMenuGroup({ meeting, decisionId, type = "datatable", iconType = "icon", fromPage = "datatable", visibleMail = true }) {

    const pageType = useSelector((state) => state.meeting.pageType);
    const [unclearSignatureDialogStatus, setUnclearSignatureDialogStatus] = useState(false);
    const [docType, setDocType] = useState('');
    const authUser = useSelector(state => state.auth.authUser);
    const userRoles = authUser && authUser.userRoles;


    const fullReportMenuItems = [
        { type: 'divider' },
        { title: "PDF Raporları", type: 'header' },
        { title: "PDF Gündem Maddelerini Dosyaya Aktar", type: 1 },
        { title: "PDF Tüm Kararları Dosyaya Aktar", type: 2 },
        { title: "PDF Üyeleri Dosyaya Aktar", type: 3 },
        { title: "PDF Üyeleri Detaylı Olarak Dosyaya Aktar", type: 4 },
        { title: "PDF Katılımcıları Detaylı Olarak Dosyaya Aktar", type: 5 },

        ...(pageType !== undefined && (pageType === "1" || pageType === "3") ? [
            { title: "PDF Tek Tek Kararları Dosyaya Aktar(İmza Belirli)", type: 18 },
            { title: "PDF Tek Tek Kararları Dosyaya Aktar(İmza Belirsiz)", type: 19 },
        ] : []),

        { type: 'divider' },
        { title: "WORD Raporları", type: 'header' },
        { title: "WORD Gündem Maddelerini Dosyaya Aktar", type: 6 },
        { title: "WORD Tüm Kararları Dosyaya Aktar", type: 7 },
        { title: "WORD Üyeleri Dosyaya Aktar", type: 12 },
        { title: "WORD Üyeleri Detaylı Olarak Dosyaya Aktar", type: 13 },
        { title: "WORD Katılımcıları Detaylı Olarak Dosyaya Aktar", type: 14 },

        ...(pageType !== undefined && (pageType === "1" || pageType === "3") ? [
            { title: "WORD Tek Tek Kararları Dosyaya Aktar(İmza Belirli)", type: 20 },
            { title: "WORD Tek Tek Kararları Dosyaya Aktar(İmza Belirsiz)", type: 21 },
        ] : []),

        ...(visibleMail ? [
            { type: 'divider' },
            { title: "E-Posta/SMS Gönderim İşlemleri", type: 'header' },
            { title: "Gündem Listesini(PDF) Üye ve Katılımcılara EPosta Gönder", type: 15 },
            { title: "Karar Listesini(PDF) Üye ve Katılımcılara EPosta Gönder", type: 16 },
            { title: "Gündem ve Karar Listelerini(PDF) Üye ve Katılımcılara EPosta Gönder", type: 17 },
        ] : []),
    ];

    const limitedReportMenuItems = [
        { title: "Raporlar", type: 'header' },
        { title: "PDF Gündem Maddelerini Dosyaya Aktar", type: 1 },
        { title: "PDF Tüm Kararları Dosyaya Aktar", type: 2 },
        { title: "WORD Gündem Maddelerini Dosyaya Aktar", type: 6 },
        { title: "WORD Tüm Kararları Dosyaya Aktar", type: 7 },
    ];

    const reportMenuItems = isRoleCheckList(userRoles, [1, 370, 372, 373, 369])
        ? fullReportMenuItems
        : limitedReportMenuItems;




    const agendaReportMenuItems = [
        { title: "PDF Gündem Maddelerini Dosyaya Aktar", type: 1 },
        { title: "PDF Tek Gündemi Dosyaya Aktar", type: 8 },
        { title: "PDF Tek Kararı Dosyaya Aktar", type: 9 },
        { title: "WORD Gündem Maddelerini Dosyaya Aktar", type: 6 },
        { title: "WORD Tek Gündemi Dosyaya Aktar", type: 10 },
        { title: "WORD Tek Kararı Dosyaya Aktar", type: 11 }
    ];

    const menu = type === "agenda" ? agendaReportMenuItems : reportMenuItems;


    const reportButtonsClick = async (id, option, meetingId = 0) => {
        // id = "263";

        if (option.type === 1) {
            await getReportListByMeetingIdPDFApi(id, "agenda")

        } else if (option.type === 2) {
            await getReportListByMeetingIdPDFApi(id, "decision")
        } else if (option.type === 3) {
            await getUsersByMeetingIdPDFApi(id, "user")
        } else if (option.type === 4) {
            await getUsersByMeetingIdPDFApi(id, "detail")
        } else if (option.type === 5) {
            await getUsersByMeetingIdPDFApi(id, "participant")
        } else if (option.type === 12) {
            await getUsersByMeetingIdWORDFApi(id, "user", "Üye Listesi")
        } else if (option.type === 13) {
            await getUsersByMeetingIdWORDFApi(id, "detail", "Detaylı Üye Listesi")
        } else if (option.type === 14) {
            await getUsersByMeetingIdWORDFApi(id, "participant", "Katılımcı Listesi")
        } else if (option.type === 6) {
            if (fromPage === "detail") {
                await getReportListByMeetingIdWORDApi(meeting.meetingId, "agenda", createReportFileName("GündemListesi", meeting))
            } else {
                await getReportListByMeetingIdWORDApi(id, "agenda", createReportFileName("GündemListesi", meeting))
            }
        } else if (option.type === 7) {
            await getReportListByMeetingIdWORDApi(id, "decision", createReportFileName("KararListesi", meeting))
        } else if (option.type === 8) {
            await getOneRecordByIdPDFApi(id, decisionId, "agenda")
        } else if (option.type === 9) {
            await getOneRecordByIdPDFApi(id, decisionId, "decision")
        } else if (option.type === 10) {
            await getOneRecordByIdWORDApi(id, decisionId, "agenda", createReportFileName("Gündem", meeting))
        } else if (option.type === 11) {
            await getOneRecordByIdWORDApi(id, decisionId, "decision", createReportFileName("Karar", meeting))
        } else if (option.type === 15) {
            await sendMailByMeetingIdPDFApi(id, "agenda", "mail", "agenda")
        } else if (option.type === 16) {
            await sendMailByMeetingIdPDFApi(id, "decision", "mail", "decision")
        } else if (option.type === 17) {
            await sendMailByMeetingIdPDFApi(id, "agendaDecision", "mail", "agendaDecision")
        } else if (option.type === 18) {
            await getPDFForEachDecisionByMeetingIdPDFApi(id)
        } else if (option.type === 19) {
            setUnclearSignatureDialogStatus(true);
            setDocType("pdf");
        } else if (option.type === 20) {
            await getForEachDecisionByMeetingIdWORDApi(id)
        } else if (option.type === 21) {
            setDocType("word");
            setUnclearSignatureDialogStatus(true);
        }


    }

    const trigger = iconType === "button" ? (

        <Button variant="inherit" size="small" sx={{ fontSize: '10px' }}>
            Raporlar
        </Button>
    ) : (
        <FileCopyIcon style={{ fontSize: 18, display: 'block', margin: 'auto' }} />

    );








    return (

        <>
            <JumboDdMenu
                icon={trigger}
                menuItems={menu}
                onClickCallback={(option) =>
                    reportButtonsClick(fromPage === "detail" ? meeting.meetingId : meeting.id, option)
                }
            />



            <UnclearSignatureDialog
                open={unclearSignatureDialogStatus}
                onClose={() => setUnclearSignatureDialogStatus(false)}
                // meeting.id={"263"}
                meetingId={(meeting !== undefined && meeting.id !== undefined) ? meeting.id : 0}
                docType={docType}
            />
        </>

    );
}

export default ReportMenuGroup